import { useEffect, useRef, useState } from 'react'
import './App.css'

function Footer() {
    const [year, setYear] = useState()
    useEffect(() => {
        let cur = new Date()
        setYear(cur.getFullYear())
    }, [])

    return (
        <div className="footer">
            <div className="footer-highblock">
                <div className="footer-row">
                    <div className="main-text contacts-text">
                        <span>
                            <b>Наша почта:</b>
                        </span>
                        <a href="mailto:info@alsfund.ru">info@alsfund.ru</a>
                    </div>
                    <div className="main-text contacts-text">
                        <span>
                            <b>Наш телефон: </b>
                        </span>
                        <a href="callto:info@alsfund.ru">+7 (495) 968-56-26</a>
                    </div>
                    <div className="main-text contacts-text">
                        <span>
                            <b>Для СМИ:</b>
                        </span>
                        <a href="mailto:pr@alsfund.ru">pr@alsfund.ru</a>
                    </div>
                    <div className="main-text contacts-text">
                        <span>
                            <b>Создан при поддержке:</b>
                        </span>
                        <a href="https://www.nic.ru/">RU-CENTER</a>
                    </div>
                </div>
                <div className="footer-links">
                    <a
                        target="_blank"
                        href="https://alsfund.ru/wp-content/uploads/2022/01/Politika-obrabotki-personalnyih-dannyih_alsfund.pdf"
                    >
                        Политика конфиденциальности
                    </a>
                    <a
                        target="_blank"
                        href="https://alsfund.ru/wp-content/uploads/2021/12/Publichnaya-oferta.pdf"
                    >
                        Публичная оферта о заключении договора
                        благотворительного пожертвования
                    </a>
                </div>
            </div>
            <div className="footer-lowblock">
                <p className="self-fs">
                    Благотворительный фонд &laquo;Живи сейчас&raquo; создали
                    люди с&nbsp;БАС и&nbsp;их близкие. <br /> Все
                    мы&nbsp;объединились ради большой цели&nbsp;&mdash;
                    всесторонне развивать помощь людям с&nbsp;БАС, по&nbsp;всей
                    России.
                </p>
                <div className="self-fe">
                    <span>{year}</span> © БФ «Живи сейчас»
                </div>
            </div>
            <img
                className="footer-flower"
                src={process.env.PUBLIC_URL + 'footer-flower.svg'}
            />
        </div>
    )
}

export default Footer
